// ══════════════════════════════════════════════════════════
// SYSTÈME DE NIVEAUX COLOBONGO — 55 NIVEAUX
// Thème : Progression d'artiste cozy
// ══════════════════════════════════════════════════════════

export const levels = [
  { level: 1, name: "Little Brush", nameFr: "Petit Pinceau", xpRequired: 0, emoji: "🖌️" },
  { level: 2, name: "Curious Créative", nameFr: "Curieux Créatif", xpRequired: 100, emoji: "🔍" },
  { level: 3, name: "Color Apprentice", nameFr: "Apprenti Couleur", xpRequired: 250, emoji: "🎨" },
  { level: 4, name: "Tint Explorer", nameFr: "Explorateur de Teintes", xpRequired: 450, emoji: "🧭" },
  { level: 5, name: "Pencil Friend", nameFr: "Ami des Crayons", xpRequired: 700, emoji: "✏️" },
  { level: 6, name: "Color Dreamer", nameFr: "Rêveur en Couleurs", xpRequired: 1000, emoji: "💭" },
  { level: 7, name: "Beginner Blender", nameFr: "Mélangeur Débutant", xpRequired: 1350, emoji: "🌀" },
  { level: 8, name: "Soft Touch", nameFr: "Touche Douce", xpRequired: 1750, emoji: "🪶" },
  { level: 9, name: "Créative Soul", nameFr: "Âme Créative", xpRequired: 2200, emoji: "✨" },
  { level: 10, name: "Budding Artist", nameFr: "Artiste en Herbe", xpRequired: 2700, emoji: "🌱" },
  { level: 11, name: "Shade Keeper", nameFr: "Gardien des Nuances", xpRequired: 3250, emoji: "🌓" },
  { level: 12, name: "Palette Weaver", nameFr: "Tisseur de Palettes", xpRequired: 3850, emoji: "🧵" },
  { level: 13, name: "Colorful Heart", nameFr: "Cœur Coloré", xpRequired: 4500, emoji: "💜" },
  { level: 14, name: "Light Dancer", nameFr: "Danseur de Lumière", xpRequired: 5200, emoji: "💃" },
  { level: 15, name: "Bongo's Friend", nameFr: "Ami de Bongo", xpRequired: 5950, emoji: "🤝" },
  { level: 16, name: "Shadow Hunter", nameFr: "Chasseur d’Ombres", xpRequired: 6750, emoji: "🎯" },
  { level: 17, name: "Pencil Poet", nameFr: "Poète du Crayon", xpRequired: 7600, emoji: "📝" },
  { level: 18, name: "Gradient Master", nameFr: "Maître Dégradé", xpRequired: 8500, emoji: "🌈" },
  { level: 19, name: "Page Enchanter", nameFr: "Enchanteur de Pages", xpRequired: 9450, emoji: "📖" },
  { level: 20, name: "Rising Virtuoso", nameFr: "Virtuose en Devenir", xpRequired: 10450, emoji: "⭐" },
  { level: 21, name: "Fridge Guardian", nameFr: "Gardien du Frigo", xpRequired: 11500, emoji: "🧊" },
  { level: 22, name: "Tint Sculptor", nameFr: "Sculpteur de Teintes", xpRequired: 12600, emoji: "🗿" },
  { level: 23, name: "Rainbow Soul", nameFr: "Âme Arc-en-Ciel", xpRequired: 13750, emoji: "🌈" },
  { level: 24, name: "Creative Architect", nameFr: "Architecte Créatif", xpRequired: 14950, emoji: "🏛️" },
  { level: 25, name: "Local Legend", nameFr: "Légende Locale", xpRequired: 16200, emoji: "🏆" },
  { level: 26, name: "Marker Tamer", nameFr: "Dompteur de Marqueurs", xpRequired: 17500, emoji: "🦁" },
  { level: 27, name: "Rising Star", nameFr: "Étoile Montante", xpRequired: 18850, emoji: "🌟" },
  { level: 28, name: "Color Sage", nameFr: "Sage des Couleurs", xpRequired: 20250, emoji: "🧙" },
  { level: 29, name: "Story Weaver", nameFr: "Tisserand d’Histoires", xpRequired: 21700, emoji: "📚" },
  { level: 30, name: "Cozy Champion", nameFr: "Champion du Cozy", xpRequired: 23200, emoji: "🛋️" },
  { level: 31, name: "Texture Master", nameFr: "Maître des Textures", xpRequired: 24750, emoji: "🎭" },
  { level: 32, name: "Light Bearer", nameFr: "Porteur de Lumière", xpRequired: 26350, emoji: "🕯️" },
  { level: 33, name: "Palette Oracle", nameFr: "Oracle des Palettes", xpRequired: 28000, emoji: "🔮" },
  { level: 34, name: "Paper Hero", nameFr: "Héros du Papier", xpRequired: 29700, emoji: "🦸" },
  { level: 35, name: "Proven Enchanter", nameFr: "Enchanteur Confirmé", xpRequired: 31450, emoji: "✨" },
  { level: 36, name: "Living Legend", nameFr: "Légende Vivante", xpRequired: 33250, emoji: "👑" },
  { level: 37, name: "Secret Keeper", nameFr: "Gardien des Secrets", xpRequired: 35100, emoji: "🗝️" },
  { level: 38, name: "Blend Master", nameFr: "Maître du Blend", xpRequired: 37000, emoji: "🎨" },
  { level: 39, name: "Creative Pioneer", nameFr: "Pionnier Créatif", xpRequired: 38950, emoji: "🚀" },
  { level: 40, name: "Soul Illuminator", nameFr: "Éclaireur d’Âmes", xpRequired: 40950, emoji: "💡" },
  { level: 41, name: "Dream Architect", nameFr: "Architecte des Rêves", xpRequired: 43000, emoji: "🏰" },
  { level: 42, name: "Visual Symphonist", nameFr: "Symphoniste Visuel", xpRequired: 45100, emoji: "🎵" },
  { level: 43, name: "Tint Alchemist", nameFr: "Alchimiste des Teintes", xpRequired: 47250, emoji: "⚗️" },
  { level: 44, name: "Ancient Sage", nameFr: "Sage Ancestral", xpRequired: 49450, emoji: "📜" },
  { level: 45, name: "Flow Master", nameFr: "Maître du Flow", xpRequired: 51700, emoji: "🌊" },
  { level: 46, name: "Art Guardian", nameFr: "Gardien de l’Art", xpRequired: 54000, emoji: "🛡️" },
  { level: 47, name: "Creative Visionary", nameFr: "Visionnaire Créatif", xpRequired: 56350, emoji: "👁️" },
  { level: 48, name: "Eternal Legend", nameFr: "Légende Éternelle", xpRequired: 58750, emoji: "♾️" },
  { level: 49, name: "Color Phoenix", nameFr: "Phoenix des Couleurs", xpRequired: 61200, emoji: "🔥" },
  { level: 50, name: "Transcender", nameFr: "Transcendeur", xpRequired: 63700, emoji: "🌌" },
  { level: 51, name: "Bongo's Chosen", nameFr: "Élu de Bongo", xpRequired: 66250, emoji: "👼" },
  { level: 52, name: "Absolute Master", nameFr: "Maître Absolu", xpRequired: 68850, emoji: "🎖️" },
  { level: 53, name: "Immortal Soul", nameFr: "Âme Immortelle", xpRequired: 71500, emoji: "💫" },
  { level: 54, name: "Divine Creator", nameFr: "Créateur Divin", xpRequired: 74200, emoji: "🌟" },
  { level: 55, name: "Supreme Legend", nameFr: "Légende Suprême", xpRequired: 76950, emoji: "👑" }
];

// Fonction utilitaire pour obtenir le niveau actuel
export function getLevelInfo(xp) {
  const safeXp = Number.isFinite(Number(xp)) ? Number(xp) : 0;
  let currentLevel = levels[0];
  let nextLevel = levels[1];

  for (let i = levels.length - 1; i >= 0; i--) {
    if (safeXp >= levels[i].xpRequired) {
      currentLevel = levels[i];
      nextLevel = levels[i + 1] || null;
      break;
    }
  }

  const xpInLevel = safeXp - currentLevel.xpRequired;
  const xpForNextLevel = nextLevel ? nextLevel.xpRequired - currentLevel.xpRequired : 0;
  const progress = nextLevel ? (xpInLevel / xpForNextLevel) * 100 : 100;

  return {
    currentLevel,
    nextLevel,
    xpInLevel,
    xpForNextLevel,
    progress,
    isMaxLevel: !nextLevel
  };
}

export default levels;
